import { Provider, useDispatch } from "react-redux";
import "./App.css";
import { PageRoutes } from "./PageRouting";
import store from "./store";
import { getDataFromLocal } from "./Redux/actions/AuthActions";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db, onForegroundMessage } from "./config/firebase";
import { collection, deleteDoc, doc, onSnapshot, query, where } from "firebase/firestore";
import IncomingCallModal from "./Pages/IncomingCallModal";
import { convertUTCDate } from "./utils/convertionFunc";
import AppointmentService from "./Services/AppointmentService";
import { APP_ROUTES } from "./PageRouting/pageRoutes";

function App() {
  const dispatch = useDispatch();
  const [incomingData, setIncomingData] = useState([]);
  const navigate = useNavigate();
  const loggedUserObj = localStorage.getItem("patientData");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    const unsubscribe = onForegroundMessage((payload) => {
      console.log("Foreground Message:", payload);

      alert(`${payload.data.callerName} is calling`);

      // optional: open custom popup UI
      // setIncomingCall(payload.data)
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    const patientId = loggedUser?.patientId;
    if (!patientId) return;

    const callsRef = collection(db, "calls");

    const q = query(
      callsRef,
      where("incomingCall.receiverId", "==", patientId)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (snapshot.empty) {
        localStorage.removeItem("incoming");
        localStorage.removeItem("incomingModal");
        setIncomingData([]);
        return;
      }

      const calls = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setIncomingData(calls);
      localStorage.setItem("incoming", JSON.stringify(calls));
      localStorage.setItem("incomingModal", "true");
    });

    return () => unsubscribe();
  }, [loggedUser?.patientId]);


  // useEffect(() => {
  //   const data = localStorage.getItem("incoming");
  //   const flag = localStorage.getItem("incomingModal");

  //   if (flag && data) {
  //     setIncomingData(JSON.parse(data));
  //   }
  // }, []);

  const handleAcceptCall = async (callerId) => {
    if (!callerId) return;
    const roomObj = incomingData?.find((item) => item.incomingCall.callerId === callerId)?.incomingCall;
    localStorage.setItem("callRoomId", roomObj.roomId);

    // Clear record from firebase
    await deleteFirebaseCallRecord(callerId);

    // Navigate to call
    const currentDate = new Date();
    const formattedDate = convertUTCDate(currentDate, "YYYY-MM-DD HH:mm:ss");
    const payload = {
      appointmentId: roomObj.roomId
    }
    const res = await AppointmentService.getPatientAppointment(payload);
    const details = res.data[0];
    if (details.serviceCode !== "APPT_VIDEO") {
      return;
    }

    try {
      let payload1 = {
        patientName: details?.patientName,
        personType: "Patient",
        appointmentId: details.appointmentId,
        modifiedBy: details.userId,
        modifiedDate: formattedDate,
        patientId: details.patientId,
        queueStatus: "Y",
        userId: details.userId,
        joiningDateTime: formattedDate,
      };
      await AppointmentService.callQueueUpdate(payload1);
      // Clear popup
      const updatedState = incomingData?.filter(item => item.incomingCall.callerId !== callerId) || [];
      if (updatedState?.length === 0) {
        localStorage.removeItem("incoming");
        localStorage.removeItem("incomingModal");
      }
      else {
        localStorage.setItem("incoming", JSON.stringify(updatedState));
      }
      setIncomingData((prevState) => prevState?.filter(item => item.incomingCall.callerId !== callerId));
      navigate(APP_ROUTES.VIDEOCALL, {
        state: { selectedAppDetails: details },
      });
    } catch (error) {
      console.error("Error updating appointment or queue:", error);
    }
  };

  const handleRejectCall = async (callerId) => {
    if (!callerId) return;
    await deleteFirebaseCallRecord(callerId);
    const updatedState = incomingData?.filter(item => item.incomingCall.callerId !== callerId) || [];
    if (updatedState?.length === 0) {
      localStorage.removeItem("incoming");
      localStorage.removeItem("incomingModal");
    }
    else {
      localStorage.setItem("incoming", JSON.stringify(updatedState));
    }
  };

  const deleteFirebaseCallRecord = async (callerId) => {
    if (!callerId) return;

    try {
      await deleteDoc(doc(db, "calls", callerId));
      setIncomingData(prev =>
        prev.filter(item => item.incomingCall.callerId !== callerId)
      );
    }
    catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    dispatch(getDataFromLocal());
  }, [dispatch]);

  return (
    <>
      <PageRoutes />
      <IncomingCallModal
        data={incomingData}
        onAccept={handleAcceptCall}
        onReject={handleRejectCall}
      />
    </>
  );
}

export default App;
